import { ClassificationThresholds } from '@/models/FundLevel/Rebalancing/ClassificationThresholds';
import { ExposureData } from '@/models/FundLevel/Rebalancing/ExposureCapture';
import { GenericReportDownload } from '@/types/downloadReports';

import { createAction, createAsyncAction } from 'typesafe-actions';

import { ExpoClassLimitUpdatePayload } from '../types';

export type GetExposureSuccessPayload = {
  data: ExposureData[];
};
export const getExposureData = createAsyncAction(
  'exposure/getExposureData/request',
  'exposure/getExposureData/success',
  'exposure/getExposureData/failure',
)<undefined, GetExposureSuccessPayload, undefined>();

export type GetExpoClassTagLimitSuccessPayload = {
  data: ClassificationThresholds[];
};
export const getExpoClassTagLimit = createAsyncAction(
  'exposure/getExpoClassTagLimit/request',
  'exposure/getExpoClassTagLimit/success',
  'exposure/getExpoClassTagLimit/failure',
)<undefined, GetExpoClassTagLimitSuccessPayload, undefined>();

export type ExposureApprovalRequestPayload = {
  approval_id_list: number[];
  approve_action: boolean;
};

export const approveExposure = createAsyncAction(
  'exposure/approveExposure/request',
  'exposure/approveExposure/success',
  'exposure/approveExposure/failure',
)<ExposureApprovalRequestPayload, undefined, undefined>();

export type ExpoClassLimitRequestPayload = {
  expo_limit_record_list: ExpoClassLimitUpdatePayload[];
};

export const updateExpoClassLimit = createAsyncAction(
  'exposure/updateExpoClassLimit/request',
  'exposure/updateExpoClassLimit/success',
  'exposure/updateExpoClassLimit/failure',
)<ExpoClassLimitRequestPayload, undefined, undefined>();

export type UploadExposureFileRequestPayload = {
  file: File;
};

export const uploadExposureFile = createAsyncAction(
  'exposure/uploadExposureFile/request',
  'exposure/uploadExposureFile/success',
  'exposure/uploadExposureFile/failure',
)<UploadExposureFileRequestPayload, undefined, undefined>();

export type DownloadTemplateSuccessPayload = {
  data: GenericReportDownload;
};

export type DownloadTemplateRequestPayload = {
  template_type: 'deal_name' | 'non_deal_name' | 'legacy';
};
export const downloadRebalancingTemplate = createAsyncAction(
  'exposure/downloadTemplate/request',
  'exposure/downloadTemplate/success',
  'exposure/downloadTemplate/failure',
)<DownloadTemplateRequestPayload, DownloadTemplateSuccessPayload, undefined>();
